<script setup>
import { computed, onMounted, ref, watch, defineModel } from "vue";
import { useFVStore } from "@/stores/formvibes";
import { storeToRefs } from "pinia";
import { VueDraggableNext } from 'vue-draggable-next'
import { View, Hide, Refresh } from "@element-plus/icons-vue"

const store= useFVStore();;
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: true
    },
    columns: Array, // Pass columns as a prop
    prevCol: Array, // Pass prevCol as a prop
});

const emit = defineEmits();


const { columns, generalStates, data,isSaving } = storeToRefs(store);

const i18n = window.fvGlobalVar?.i18n;

// Watch for changes in columns
// watch(
//     () => props.columns,
//     (newColumns, oldColumns) => {
//         console.log(newColumns);
//         const hasChanged = !arraysEqual(newColumns, props.prevCol);
//         emit('update:modelValue', hasChanged);
//     },
//     { deep: true } // Deep watch to detect nested changes
// );


const changeVisible = (data,key) => {
    if(key === 'visible'){
        data.visible = !data.visible;
    }
    columns.value.forEach((col) => {
        if (col.id === data.id) {
            columns.value[col.id] = data;
        }
    });
    emit('update:modelValue', true);
}

// Helper function to compare arrays
const arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every((val, index) => val.visible === b[index].visible);
};

const allowDrop = (draggingNode, dropNode, type) => {
    if(type === 'inner'){
        return false;
    }
    return true
}


</script>
<template>
    <div v-if="!isSaving" class="">
        <div class="fv-setting-col-header">
            <span class="fv-setting-label">
                {{i18n?.field_name}}
            </span>
            <span>
                {{i18n?.column_label}}
            </span>
            <span>
                {{i18n?.column_visibility}}
            </span>
        </div>
        <div className="fv-settings-wrapper" style="max-height: 500px,overflow: scroll," >
            <el-tree
                :allow-drop="allowDrop"
                allow-drag="true"
                draggable
                default-expand-all
                node-key="id"
                :data="columns"
            >
                <template  #default="{ node, data }">
                    <div class="fv-settings-item">
                        {{ data.colKey }}
                        <el-input v-model="data.alias" placeholder="Please input" @keydown="changeVisible(data,key='alias')" />
                        <el-button v-if="data.visible" @click="changeVisible(data,key='visible')" link >
                            <el-icon>
                                <View />
                            </el-icon>
                        </el-button>
                        <el-button v-if="!data.visible" @click="changeVisible(data,key='visible')" link  class="fv-hide-col" :class="{'fv-hide-col-active': !data.visible}">
                            <el-icon>
                                <Hide />
                            </el-icon>
                        </el-button>
                    </div>
                </template>
            </el-tree>
        </div>
    </div>
    <div v-else class="fv-sub-col-set-loader">
        <el-icon size="50"><Refresh /></el-icon>
    </div>
</template>